export default __webpack_public_path__ + "static/media/chartres9.995dc579.jpg";